import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { IPartnerData, WhitelabelProductFeatures } from '@models/WhitelabelConfig';
import { Observable } from 'rxjs';

import { BrandConfigStore } from './brand.store';

@Injectable({ providedIn: 'root' })
export class BrandConfigQuery extends Query<IPartnerData> {
	constructor(protected store: BrandConfigStore) {
		super(store);
	}

	/** Get the whole brandConfig JSON that has all of the brand configs */
	public readonly brandConfig$ = (): Observable<IPartnerData> => this.select(state => state);
	/** Get the logo CDN URL used for the branded logo */
	public readonly logoTarget$ = (): Observable<string> => this.select(state => state.whiteLabelConfig?.quote?.logoUrlTarget);
	/** The brand phone number that will be displayed to the user */
	public readonly phone$ = (): Observable<string> => this.select(state => state.partnerPhoneNumber);
	/** The brand's true/false value that determines of the Agent Information form should be displayed to the user */
	public readonly showAgentForm$ = (): Observable<boolean> => this.select(state => state.whiteLabelConfig?.quote?.showAgentForm);
	public readonly featureFlags$ = (): Observable<WhitelabelProductFeatures> => this.select(state => state.productFeatures);
	/**
	 * Gets a non-observable value for the brand config at the time it's queried
	 *
	 * @deprecated
	 */
	public readonly brandConfigRawValue = (): IPartnerData => this.getValue();
}
